import { Box, type BoxProps } from '@mui/material';

import useStyles from './Paper.styles';

export interface PaperProps extends BoxProps {
  glow?: boolean;
  /**
   * Overrides the thickness, in px, of the border drawn by `glow`.
   * Defaults to the glow's built-in 1px border; has no effect without `glow`.
   */
  borderWidth?: number;
}

export default function Paper({
  children,
  glow,
  borderWidth,
  className,
  ...props
}: PaperProps) {
  const { cx, classes } = useStyles({ borderWidth });

  return (
    <Box
      className={cx(
        classes.root,
        {
          [classes.glow]: glow,
          [classes.glowBorderWidth]: glow && borderWidth !== undefined,
        },
        className
      )}
      {...props}
    >
      {children}
    </Box>
  );
}
